import { Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { AuthorMinStdOverview } from '@/module/MinimalStandard/AuthorMinStdOverview';
import { MinStdNotOpened } from '@/module/MinimalStandard/MinStdNotOpened';
import { MinStdHeader } from '@/module/MinimalStandard/components/MinStdHeader';
import { getMinStdOptions } from '@/module/MinimalStandard/model/MinStdQuery';
import { MinStdReport } from '@/module/MinimalStandard/model/MinStdTypes';

import { NoContentPlaceholder } from '@/core/components';

export const Route = createFileRoute('/_auth/minimal-standards/_layout/')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'pageTitle.view' },
  },
});

function RouteComponent() {
  const userId = Route.useSearch().userId;

  const { data } = useSuspenseQuery(getMinStdOptions(userId != null ? userId : null));
  const report = data as unknown as MinStdReport | null;

  const startYear = 1990;
  const endYear = 2025;
  const jobTitle = null;

  return (
    <Stack p="md">
      {userId != null && report != null && (
        <>
          <MinStdHeader
            report={report}
            startYear={startYear}
            endYear={endYear}
            jobTitle={jobTitle}
          />
          {report.implemented && (
            <AuthorMinStdOverview
              userId={userId}
              startYear={startYear}
              endYear={endYear}
              jobTitle={jobTitle}
            />
          )}
          {!report.implemented && (
            <NoContentPlaceholder title="Anexa CNATCU selectată nu este disponibilă în platformă." />
          )}
        </>
      )}
      {userId == null && <Text>Utilizator neselectat</Text>}
      {userId != null && data == null && <MinStdNotOpened userId={userId} />}
    </Stack>
  );
}
